
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.feel-difference-slider');
  const items = document.querySelectorAll('.progress-bar li');
  const slides = document.querySelectorAll('.feel-difference-slide');

  /* ===============================
     ACTIVE DOT LOGIC (UNCHANGED)
  =============================== */
  function updateActive() {
    const maxScrollLeft = slider.scrollWidth - slider.clientWidth;

    if (slider.scrollLeft >= maxScrollLeft - 2) {
      items.forEach((li, i) => {
        li.classList.toggle('active', i === slides.length - 1);
      });
      return;
    }

    let closestIndex = 0;
    let minDiff = Infinity;

    slides.forEach((slide, index) => {
      const diff = Math.abs(slider.scrollLeft - slide.offsetLeft);
      if (diff < minDiff) {
        minDiff = diff;
        closestIndex = index;
      }
    });

    items.forEach((li, i) => {
      li.classList.toggle('active', i === closestIndex);
    });
  }

  slider.addEventListener('scroll', () => {
    requestAnimationFrame(updateActive);
  });

  items.forEach((li, index) => {
    li.addEventListener('click', () => {
      slider.scrollTo({
        left: index === slides.length - 1
          ? slider.scrollWidth
          : slides[index].offsetLeft,
        behavior: 'smooth'
      });
    });
  });

  /* ===============================
     MOUSE DRAG TO SCROLL (FIXED)
     — no preventDefault on mousedown
     — only activates after 5px threshold
     — does NOT interfere with touch
  =============================== */
  let isDown = false;
  let isDragging = false;
  let startX;
  let startScrollLeft;

  slider.addEventListener('mousedown', (e) => {
    if (e.button !== 0) return;
    isDown = true;
    isDragging = false;
    startX = e.pageX;
    startScrollLeft = slider.scrollLeft;
  });

  window.addEventListener('mouseup', () => {
    isDown = false;
    isDragging = false;
    slider.classList.remove('dragging');
  });

  window.addEventListener('mousemove', (e) => {
    if (!isDown) return;

    const walk = e.pageX - startX;

    /* Only activate drag after 5px movement — avoids accidental drag on click */
    if (!isDragging && Math.abs(walk) < 5) return;

    if (!isDragging) {
      isDragging = true;
      slider.classList.add('dragging');
    }

    e.preventDefault(); /* prevent text selection only during actual drag */
    slider.scrollLeft = startScrollLeft - walk * 1.2;
  });

  /* ===============================
     TOUCH SCROLL FIX
     — let browser handle touch natively
     — only update active dot on touchend
  =============================== */
  slider.addEventListener('touchend', () => {
    setTimeout(updateActive, 100); /* small delay to let snap settle */
  });

});
